import { Box } from '@mui/material';

type StickyWrapperProps = {
  readonly children: React.ReactNode;
  readonly sx?: object;
  readonly disableSticky?: boolean;
};

export const StickyWrapper: React.FC<StickyWrapperProps> = ({ children, sx, disableSticky }: StickyWrapperProps) => (
  <Box
    sx={{
      ...(disableSticky ? {} : { top: 0, ...sx, position: 'sticky', zIndex: (theme) => theme.zIndex.appBar + 1 }),
    }}
  >
    {children}
  </Box>
);

export const StickyWrapperWithBlur: React.FC<StickyWrapperProps> = ({ children, sx }: StickyWrapperProps) => (
  <Box
    sx={{
      top: 0,
      ...sx,
      position: 'sticky',
      zIndex: (theme) => theme.zIndex.appBar - 1,
      backgroundColor: '#fffc',
      backdropFilter: 'blur(2px)',
      pt: 2,
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
    }}
  >
    {children}
  </Box>
);
